import Button from '@eversports/klimt-primitives/legacy/Button'
import { Localized } from '../../localization/react'

interface Props {
  onAddVoucherClick: () => void
}

const VoucherSelectionReady = ({ onAddVoucherClick: handleAddVoucherClick }: Props) => (
  <Button
    variant="secondary"
    size="small"
    onClick={handleAddVoucherClick}
    sx={{ width: 'fit-content', textTransform: 'none' }}
  >
    <Localized id="add-voucher" />
  </Button>
)

export default VoucherSelectionReady
